import React, { Component } from 'react';
import '../../App.css';

// images
import category1 from '../../img/section1.jpg'
import category2 from '../../img/section2.jpg'
import category3 from '../../img/section3.jpg'

class categories extends Component {
  render() {
    return (
      <div className="categories">
        <div id='category'>
            <img src={category1} alt=''/>
            <span>NUESTRA CALIDAD</span>
            <p><br/><br/>Nuestros productos cuentan con certificaciones de calidad tanto para su exportación como para su consumo.</p>
        </div>
        <div id='category'>
            <img src={category2} alt=''/>
            <span>NUESTROS AGRICULTORES</span>
            <p><br/><br/>Nuestros agricultores son personas apacionados por la producción de alimentos frescos y de calidad. Tradición que ha pasado de generación en generación</p>
        </div>
        <div id='category'>
            <img src={category3} alt=''/>
            <span>NUESTRA INNOVACIÓN Y SUSTENTABILIDAD</span>
            <p>Pioricost tiene como uno de sus principales pilares la investigación científica, para llegar a entregar a nuestros clientes productos de la más alta calidad con responsabilidad ambiental.</p>
        </div>
      </div>
    );
  }
}

export default categories;


// WEBPACK FOOTER //
// ./src/components/home/categories.js